module.exports = __webpack_public_path__ + "img/product-xindai2.d05770c1.svg";